<template>
  <div class="request-body-cell">
    <RequestBodyTree
      v-if="structuredBody !== null"
      class="request-body-cell__tree"
      :value="structuredBody"
      :open-by-default="false"
    />
    <span v-else class="request-body-cell__preview">{{ previewValue }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import RequestBodyTree from './RequestBodyTree.vue';

const props = defineProps<{
  value: unknown;
}>();

const structuredBody = computed(() => parseStructuredBody(props.value));

const previewValue = computed(() => {
  if (props.value === null || props.value === undefined || props.value === '') {
    return '-';
  }

  const textValue = String(props.value);
  return textValue.length > 120 ? `${textValue.slice(0, 117)}...` : textValue;
});

function parseStructuredBody(value: unknown): Record<string, unknown> | unknown[] | null {
  if (Array.isArray(value)) return value;
  if (isPlainObject(value)) return value;
  if (typeof value !== 'string') return null;

  const trimmedValue = value.trim();
  if (!trimmedValue || !/^[[{]/.test(trimmedValue)) {
    return null;
  }

  try {
    const parsedValue: unknown = JSON.parse(trimmedValue);
    return Array.isArray(parsedValue) || isPlainObject(parsedValue) ? parsedValue : null;
  } catch {
    return null;
  }
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}
</script>

<style scoped>
.request-body-cell {
  width: 100%;
}

.request-body-cell__tree {
  min-width: 320px;
  max-height: 260px;
  overflow: auto;
  padding: 8px 10px;
  border-radius: 10px;
  background: var(--ion-background-color,);
}

.request-body-cell__preview {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
